import React from 'react';
import { Card as MuiCard, CardProps as MuiCardProps } from '@mui/material';

export interface CardProps extends Omit<MuiCardProps, 'variant'> {
  variant?: 'default' | 'elevated' | 'outlined' | 'interactive';
  padding?: 'none' | 'small' | 'medium' | 'large';
  hover?: boolean;
}

const Card: React.FC<CardProps> = ({
  variant = 'default',
  padding = 'medium',
  hover = false,
  children,
  ...props
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'elevated':
        return {
          boxShadow: 3,
          border: 'none'
        };
      case 'outlined':
        return {
          boxShadow: 'none',
          border: '1px solid',
          borderColor: 'grey.200'
        };
      case 'interactive':
        return {
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: 4
          }
        };
      default:
        return {
          boxShadow: 1,
          border: 'none'
        };
    }
  };

  const getPaddingStyles = () => {
    switch (padding) {
      case 'none':
        return { p: 0 };
      case 'small':
        return { p: 1 };
      case 'large':
        return { p: 3 };
      default:
        return { p: 2 };
    }
  };

  const getCardStyles = () => {
    const baseStyles = {
      borderRadius: 2,
      overflow: 'hidden',
      ...getVariantStyles(),
      ...getPaddingStyles()
    };

    if (hover) {
      return {
        ...baseStyles,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 4
        }
      };
    }

    return baseStyles;
  };

  return (
    <MuiCard
      sx={getCardStyles()}
      {...props}
    >
      {children}
    </MuiCard>
  );
};

export default Card; 